import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";

import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

import { StatusPill } from "../../order/orderTable/orderTableColumnsConfig";

import classes from "./refundInitiationDetailPage.module.css";

import { useGetRefundByIdQuery } from "../../../services/refund/refundApiSlice";

import { RefundDetailForm } from "../../../component/refund/refundDetail/RefundDetailForm";
import { usePatchRefundInitiationStatusMutation } from "../../../services/refund_initiation/refundInitiationMutationApiSlice";
import { useGetRefundInitiationByIdQuery } from "../../../services/refund_initiation/refundInitiationApiSlice";
import { RefundInitiationDetailForm } from "../../../component/refundInitiation/refundInitiationDetail/RefundInitiationDetailForm";

const refundInitiationConfig = {
  "refund requested": {
    label: "Refund Requested",
    bg: "#FFF4E5",
    color: "#FF9500",
    Icon: ClockIcon,
  },
  "refund in process": {
    label: "Refund In Process",
    bg: "#E6F0FF",
    color: "#1E56D9",
    Icon: ClockIcon,
  },
  "refund rejected": {
    label: "Refund Rejected",
    bg: "#FDECEA",
    color: "#D92D20",
    Icon: XCircleIcon,
  },
  "initiate refund (ok products)": {
    label: "Initiate Refund",
    bg: "#E6F7EF",
    color: "#00A167",
    Icon: CheckCircleIcon,
  },
  unknown: {
    label: "Unknown",
    bg: "#FFF4E5",
    color: "#FF9500",
    Icon: ClockIcon,
  },
};


export const RefundInitiationDetailPage = () => {
  const { refundInitiationId } = useParams();
  const navigate = useNavigate();

  const { data: refundInitaiaionDetail, isSuccess } = useGetRefundInitiationByIdQuery(refundInitiationId);

  const [updateRefundInitaiation, { isLoading: isUpdating }] =
    usePatchRefundInitiationStatusMutation();

  // current status → UI config
  const refundInitiationStatusKey = refundInitaiaionDetail?.status?.toLowerCase() ?? "";
  const refundInitiationStatusConfig = refundInitiationConfig[refundInitiationStatusKey];

  const handleUpdate = async (payload) => {
    try {
      const response = await updateRefundInitaiation({
        id: refundInitiationId, // <-- mutation expects `id`
        status: Number(payload.order_status), // <-- map to `status`
        remarks: payload?.remarks || undefined, // <-- optional
      }).unwrap();

      toast.success(
        response?.message?.displayMessage || "Refund updated successfully"
      );

      navigate("/refund_payments");
    } catch (err) {
      toast.error(
        err?.data?.message?.displayMessage ||
          err?.error ||
          "Failed to update refund"
      );
    }
  };

  return isSuccess ? (
    <div className={classes.wrapper}>
      <div className={classes.page}>
        <h2
          className={classes.pageTitle}
        >{`Refund ID: ${refundInitaiaionDetail?.id}`}</h2>

        <div className={classes.page__payment}>
          <h2 className={classes.page__payment__title}>Refund Status:</h2>

          {refundInitiationStatusConfig && <StatusPill {...refundInitiationStatusConfig} />}
        </div>
      </div>

      <RefundInitiationDetailForm
        initialValues={refundInitaiaionDetail}
        onSubmit={handleUpdate}
        isSubmitting={isUpdating}
      />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
